import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system'

import borders from 'airship/design-system/theme/foundations/borders'
import size from 'airship/design-system/theme/foundations/sizes'

import colors from '../foundations/colors'
import spacing from '../foundations/space'
import typography from '../foundations/typography'

const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(['container', 'label', 'icon'])

const baseStyle = definePartsStyle({
  // define the part you're going to style
  container: {
    borderRadius: borders.radii.full,
    display: 'inline-flex',
    verticalAlign: 'top',
    alignItems: 'center',
    paddingLeft: spacing['6xs'],
    paddingRight: spacing['6xs'],
    color: 'white',
  },
  label: {
    paddingLeft: spacing['5xs'],
    paddingRight: spacing['6xs'],
  },
  icon: {
    display: 'inline-flex',
    verticalAlign: 'top',
    horizontalAlign: 'center',
    alignItems: 'center',
  },
})

const subtleDraft = definePartsStyle({
  container: {
    bg: colors.background['discovery-secondary'],
    color: colors.text.discovery,
  },
})

const solidDraft = definePartsStyle({
  container: {
    bg: colors.background.discovery,
  },
})

const subtlePending = definePartsStyle({
  container: {
    bg: colors.background.accent['pink-secondary'],
    color: colors.text.accent.pink,
  },
})
const solidPending = definePartsStyle({
  container: {
    bg: colors.background.accent.pink,
  },
})

const subtleActive = definePartsStyle({
  container: {
    bg: colors.background['success-secondary'],
    color: colors.text.success,
  },
})

const solidActive = definePartsStyle({
  container: {
    bg: colors.background.success,
  },
})

const subtleCompleted = definePartsStyle({
  container: {
    bg: colors.background['info-secondary'],
    color: colors.text.info,
  },
})
const solidCompleted = definePartsStyle({
  container: {
    bg: colors.background.info,
  },
})

const subtlePaused = definePartsStyle({
  container: {
    bg: colors.background['warning-secondary'],
    color: colors.text.warning,
  },
})

const solidPaused = definePartsStyle({
  container: {
    bg: colors.background.warning,
  },
})

const subtleDeleted = definePartsStyle({
  container: {
    bg: colors.background['error-secondary'],
    color: colors.text.error,
  },
})

const solidDeleted = definePartsStyle({
  container: {
    bg: colors.background.error,
  },
})

const subtleArchived = definePartsStyle({
  container: {
    bg: colors.background.tertiary,
    color: colors.text.secondary,
  },
})
const solidArchived = definePartsStyle({
  container: {
    bg: colors.background.contrast,
  },
})

const sizes = {
  sm: {
    container: {
      minWidth: size['3xs'],
      minHeight: size['3xs'],
      maxHeight: size['3xs'],
      ...typography.textStyles.body.small,
    },
    icon: {
      width: size['5xs'],
      height: size['5xs'],
    },
  },
  md: {
    container: {
      minWidth: size['2xs'],
      minHeight: size['2xs'],
      maxHeight: size['2xs'],
      ...typography.textStyles.body.medium,
    },
    icon: {
      width: size['4xs'],
      height: size['4xs'],
    },
  },
  lg: {
    container: {
      minWidth: size.xs,
      minHeight: size.xs,
      maxHeight: size.xs,
      ...typography.textStyles.body.large,
    },
    icon: {
      width: size['3xs'],
      height: size['3xs'],
    },
  },
}
const StatusBadgeTheme = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants: {
    solidDraft,
    subtleDraft,
    subtlePending,
    solidPending,
    subtleActive,
    solidActive,
    subtlePaused,
    solidPaused,
    subtleCompleted,
    solidCompleted,
    subtleDeleted,
    solidDeleted,
    subtleArchived,
    solidArchived,
  },
  defaultProps: {
    variant: 'subtleDraft',
    size: 'md',
  },
})
export default StatusBadgeTheme
